<template>
    <Content>
        <div class="questions-categories">
            <template v-for="(qc, key) in quiz.category_questions">
                <QuestionCategory
                    v-show="page == key + 1"
                    :key="qc.id"
                    :categoryQuestion="qc"
                />
            </template>
        </div>
        <div class="quiz-progress">
            <button
                v-for="(progress, key) in quiz.category_questions"
                :key="progress.id"
                type="button"
                :class="[key + 1 <= page && 'active']"
                @click.prevent="page = key + 1"
            >
                <span></span>
            </button>
        </div>
        <div class="mt-2">
            <div class="float-left">
                <PrimaryButton
                    v-if="page > 1"
                    type="button"
                    @click.prevent="page = page - 1"
                >
                    Voltar
                </PrimaryButton>
            </div>
            <div class="float-right d-flex">
                <PrimaryButton
                    v-if="page < quiz.category_questions.length"
                    type="button"
                    @click.prevent="page = page + 1"
                >
                    Continuar
                </PrimaryButton>
                <PrimaryButton
                    v-if="page == quiz.category_questions.length"
                    type="submit"
                    class="ml-2"
                    @click.prevent="handleSubmit"
                >
                    Enviar
                </PrimaryButton>
            </div>
        </div>
    </Content>
</template>

<script>
import { Content } from "./style";
import { mapActions, mapState } from "vuex";
import QuestionCategory from "../QuestionCategory";
import { swall } from "../../../services/sweetAlert";
import { PrimaryButton } from "../../../components/Styles/Extends/styled";

export default {
    name: "QuestionsCategories",
    components: {
        QuestionCategory,
        Content,
        PrimaryButton
    },
    data() {
        return {
            page: 1
        };
    },
    methods: {
        ...mapActions("quizzes", ["ActionCreateQuiz"]),
        handleSubmit() {
            let isInvalid = false;
            this.quiz.category_questions.map(ct => {
                ct.questions.map(q => {
                    if (q.answers.every(a => !a.checked)) {
                        isInvalid = true;
                        return;
                    }
                });
            });
            if (isInvalid) {
                swall("Responda todas as questões para enviar!", true);
                return;
            }

            this.ActionCreateQuiz(this.quiz)
                .then(() => {
                    window.location.href += "/resultado";
                })
                .catch(error => {
                    swall(error?.msg ?? error?.message ?? error);
                });
        }
    },
    watch: {
        page(page, old_page) {
            if (page != old_page) {
                window.scroll(0, 0);
            }
        }
    },
    computed: {
        ...mapState("quizzes", ["quiz"])
    }
};
</script>
